import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ModifierComboGroupButton(props) {
    // Returns Group button displayed in group container inside a modifier combo

    let buttonImageToDisplay;
    let productTextDisplay;
    let modifierDisplayContainer, priceInc, priceIncToDisplay = "";
    let hasErrorClass = "";
    if (props.modComboGroupFormData.ValidationModComboGroup.HasError) {
        hasErrorClass = "is-invalid border-danger";
    } else {
        hasErrorClass = "";
    }

    if (props.modComboGroupFormData.Quantity === 0 || props.modComboGroupFormData.Quantity === '0') {
        productTextDisplay = `Choose ${props.modifierComboGroupDetails.modCategoryName}`
        buttonImageToDisplay = <span className="bg-dark rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}><img src={plusIcon} alt="Add" title="Add" style={{width: "10px"}}></img></span>
        modifierDisplayContainer = <></>;
    } else {
        // Format price to display
        priceIncToDisplay = CommonUtilities.formatDisplayPrice(props.modComboGroupFormData.PriceInc);
        productTextDisplay = `${props.modifierComboGroupDetails.modCategoryName}`
        buttonImageToDisplay = <span className="bg-success rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}><img src={checkIcon} alt="Selected" style={{width: "10px"}}></img></span>
        modifierDisplayContainer =
            <small className="text-muted">
                <ul className="mb-0">
                    <li>{props.modComboGroupFormData.ModifierName}<span className="ms-2 ps-1">{priceIncToDisplay}</span></li>
                </ul>
            </small>
    }

    return (
        <>
            <div className="col-12 py-2 d-grid">
                <button type="button" className={`btn btn-light border d-flex flex-row justify-content-start align-items-center py-3 ${hasErrorClass}`} data-modcombogroupindex={props.modComboGroupIndex} onClick={props.handleModifierComboGroupSelect}>
                    {buttonImageToDisplay}
                    &emsp;<div className="d-flex flex-column align-items-start text-start text-break">
                        <span>{productTextDisplay}</span>
                         {modifierDisplayContainer}
                    </div>
                </button>
                <div className="invalid-feedback">{props.modComboGroupFormData.ValidationModComboGroup.ErrorMessage}</div>
            </div>
        </>
    )
}